import { infoColor, infoBoxShadow, whiteColor, hexToRgbBlur } from '../global';

const registrationViewerStyle = (theme) => ({
    colorTextInput: {
        '& input': {
            color: '#4b4b4b',
        },
        '& > div': {
            backgroundColor: whiteColor,
        },
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
    wrapper: {
        backgroundColor: (props) => props?.customColor?.screen_background_color || whiteColor,
    },
    marginAuto: {
        margin: 'Auto',
    },
    marginBt5vh: {
        marginBottom: '5vh',
    },
    marginBt2vh: {
        marginBottom: '2vh',
    },
    margin2vh: {
        margin: '2vh',
        [theme.breakpoints.down('xs')]: {
            margin: '2vh 0',
        },
    },
    paddingRight3vW: {
        paddingRight: '3vW',
        '& div': {
            color: (props) => props?.customColor?.button_background_color?.common_button,
        },
    },
    colorIconRadio: {
        '& div': {
            color: (props) => props?.customColor?.button_background_color?.common_button,
        },
    },
    paddingLefe3vW: {
        paddingLeft: '3vW',
    },
    marginTop20: {
        marginTop: 20,
    },
    paddingTop5vh: {
        paddingTop: '5vh',
        [theme.breakpoints.down('xs')]: {
            padding: '14px 0px',
        },
    },
    textCenter: {
        textAlign: 'center',
    },
    textRight: {
        textAlign: 'right',
    },
    textLeft: {
        textAlign: 'left',
    },
    displayTextInline: {
        display: 'inline',
    },
    container: {
        marginTop: '7vh',
        marginBottom: '5vh',
        textAlign: 'center',
    },
    image: {
        zIndex: 10,
    },
    tooltipStyle: {
        marginTop: -30,
        marginLeft: (props) => (!props?.registrations?.free_seminar && props?.registrations?.free_exhibition ? 0 : -30),
    },
    tooltipStyleEN: {
        marginTop: -30,
        marginLeft: (props) => (!props?.registrations?.free_seminar && props?.registrations?.free_exhibition ? 0 : -10),
    },
    formInputInformation: {
        border: '1px solid',
        borderColor: (props) => props?.customColor?.sidebar?.background_color || infoColor,
        borderRadius: '8px',
        boxShadow: (props) => (
            (props?.customColor?.sidebar?.background_color && `0 12px 20px -10px rgba(${hexToRgbBlur(props?.customColor?.sidebar?.background_color, 0.28)}),
            0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(${hexToRgbBlur(props?.customColor?.sidebar?.background_color, 0.2)})`)
            || '0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)'),
        paddingLeft: '20px',
        paddingRight: '20px',
        maxWidth: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
        zIndex: 20,
        background: (props) => props?.customColor?.screen_background_color || whiteColor,
        paddingTop: '5vh',
        paddingBottom: '5vh',
    },
    background: {
        width: '100%',
        minHeight: (props) => (!props?.registrations?.free_seminar && props?.registrations?.free_exhibition ? '400px' : '500px'),
        [theme.breakpoints.down('sm')]: {
            minHeight: (props) => (!props?.registrations?.free_seminar && props?.registrations?.free_exhibition ? '400px' : '500px'),
        },
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: (props) => props?.customColor?.screen_background_color || whiteColor,
        display: 'flex',
        borderRadius: '8px',
    },
    spacing: {
        padding: '15px 0',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: '4px 0px',
            '& .MuiGrid-item': {
                padding: '0px 0px 7px 0px',
            },
        },
    },
    note: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    number: {
        color: whiteColor,
        background: 'orange',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        minWidth: '25px',
        textAlign: 'center',
        fontWeight: 700,
        padding: 2,
    },
    noteContent: {
        paddingLeft: theme.spacing(1.25),
        paddingRight: 0,
        color: (props) => props?.customColor?.contents_text_color,
    },
    eventInfo: {
        display: 'flex',
        alignItems: 'center',
        margin: '2vh',
        [theme.breakpoints.down('xs')]: {
            margin: '2vh 0',
        },
    },
    divider: {
        marginTop: '15px',
        [theme.breakpoints.up('md')]: {
            marginLeft: '15px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '-15px',
            marginRight: '-15px',
        },
    },
    paddingTop15: {
        paddingTop: '15px',
    },
    margin28: {
        marginLeft: '28px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '14px',
        },
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '250px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: { fontSize: '24px !important', minWidth: '150px !important', margin: '10px  !important' },
    },
});

export default registrationViewerStyle;
